import type { ChangeEntry, Claim } from "../domain";

export const ChangeLog = ({ changes, claims }: { changes: ChangeEntry[]; claims: Claim[] }) => {
  const claimsById = new Map(claims.map((claim) => [claim.id, claim]));
  return (
    <section className="section-block" id="changes" aria-labelledby="changes-heading">
      <div className="section-heading">
        <div>
          <h2 id="changes-heading">Change log</h2>
          <p>Append-only history of what entered or left the current state.</p>
        </div>
        <a href="/changes.json">View JSON <span aria-hidden="true">→</span></a>
      </div>
      <ol className="change-list">
        {changes.map((change) => {
          const claim = claimsById.get(change.claimId);
          return (
            <li key={change.id}>
              <time dateTime={change.changedAt}>{change.changedAt.slice(0, 10)}</time>
              <span className={`change-action action-${change.action}`}>{change.action}</span>
              <span>{claim?.title ?? change.note}</span>
            </li>
          );
        })}
      </ol>
    </section>
  );
};

